/**
 * tên cột active
 */
export default {
  Active:'is_active'
};
